import { BLACK_d, BLACK_e, MAIN_GREEN } from "baseStyles";
import { MOBILE_LAYOUT_LENGTH } from "constants/UIConstants";
import styled from "styled-components";

export const Container = styled.div`
  margin-top: 30rem;
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    margin-top: 15rem;
  }
`;

export const TextBox1 = styled.div`
  & > div:nth-child(1) {
    font-weight: 700;
    font-size: 5.2rem;
    line-height: 9.2rem;
  }
  & > div:nth-child(2) {
    font-weight: 300;
    font-size: 2.2rem;
    line-height: 3.8rem;
    color: ${BLACK_d};
  }
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    & > div:nth-child(1) {
      display: flex;
      flex-direction: column;
      font-size: 3.2rem;
      line-height: 5.4rem;
    }
    & > div:nth-child(2) {
      font-size: 1.8rem;
      line-height: 3.2rem;
    }
  }
`;

export const ContentWrap = styled.div`
  display: flex;
  flex-direction: row-reverse;
  padding-top: 8.5rem;
  margin-right: 2rem;
  gap: 6rem;
  margin-bottom: 47.3rem;
  & > img {
    margin-top: 1.4rem;
    width: 2rem;
    height: 58.2rem;
    padding-top: 0rem;
  }
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    flex-direction: row-reverse;
    padding-top: 6rem;
    margin-bottom: 25rem;
    margin-right: 0rem;
    gap: 2rem;
    padding-left: 20px;
    & > img {
      margin-top: 0.5rem;
    }
  }
`;

export const TextBoxWrap = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TextBox2 = styled.div`
  display: flex;
  flex-direction: column;

  gap: 1rem;
  &:nth-child(2) {
    margin-top: 9.7rem;
    @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
      margin-top: 5.9rem;
    }
  }
  &:nth-child(4) {
    margin-top: 14.6rem;
    & > div {
      display: flex;
      flex-direction: column;
    }
    @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
      margin-top: 13.7rem;
      & > div {
        display: flex !important;
        flex-direction: column;
      }
    }
  }

  & > div:nth-child(1) {
    font-weight: 700;
    font-size: 2.4rem;
    line-height: 4.2rem;
  }
  & > div:nth-child(2) {
    display: flex;
    flex-direction: column;
    font-weight: 300;
    font-size: 1.8rem;
    line-height: 3.2rem;
    color: ${BLACK_e};
  }
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    width: 29.3rem;
    gap: 0.5rem;
    &:nth-child(2) {
      margin-top: ${(props) => (props.language === "en" ? "3rem" : "")};
    }
    &:nth-child(4) {
      margin-top: ${(props) => (props.language === "en" ? "11rem" : "")};
    }
    & > div:nth-child(1) {
      font-size: 2rem;
      line-height: 3.6rem;
    }
    & > div:nth-child(2) {
      display: block;
      font-size: 1.6rem;
      line-height: 2.8rem;
    }
  }
`;

export const TextBox3 = styled.div`
  cursor: pointer;
  margin-top: 3rem;
  font-weight: 300;
  font-size: 1.6rem;
  line-height: 2.8rem;
  width: fit-content;
  color: ${MAIN_GREEN};

  border-bottom: 1px solid ${MAIN_GREEN};
`;
